import React, { createContext, useContext } from 'react';

import { IDashboardSection } from '~/src/dash/views/dashboards/DashboardHome/configs/dashboardsConfig';

interface IDashboardsStore {
  activeSection: number;
  setActiveSection: React.Dispatch<React.SetStateAction<number>>;
  sections: IDashboardSection[];
  isPublica: boolean;
  isParentPublisher: boolean;
}

export const DashboardsContext = createContext({} as IDashboardsStore);
export const useDashboardsStore = (): IDashboardsStore => useContext(DashboardsContext);
